import React from 'react'
import { Checkbox, Menu } from 'antd-v4'
import { CheckboxOptionType } from 'antd-v4/lib/checkbox/Group'
import { ColumnKeys, ColumnTitles } from './enums'
import { TInventoryOnHandColumns } from './types'

interface IColumnOption extends CheckboxOptionType {
  label: ColumnTitles
  value: ColumnKeys
}
const options: IColumnOption[] = [
  {
    label: ColumnTitles.CATEGORY,
    value: ColumnKeys.CATEGORY,
  },
  {
    label: ColumnTitles.BRAND,
    value: ColumnKeys.BRAND,
  },
  {
    label: ColumnTitles.UNIT_PRICE,
    value: ColumnKeys.UNIT_PRICE,
  },
  {
    label: ColumnTitles.MARGIN,
    value: ColumnKeys.MARGIN,
  },
]

interface Props {
  onChange: (columnKeys: TInventoryOnHandColumns) => void
  defaultColumns: TInventoryOnHandColumns
}

export const ShowTableColumnsMenu = ({ onChange, defaultColumns }: Props) => {
  return (
    <Menu style={{ padding: 10 }}>
      <Checkbox.Group
        onChange={(columnKeys) => onChange(columnKeys as TInventoryOnHandColumns)}
        defaultValue={defaultColumns}
        options={options}
        style={{ display: 'flex', flexDirection: 'column' }}
      />
    </Menu>
  )
}
